import axios from "axios";
import { LOCAL_STORAGE } from "../utils/constants";

const DeleteAxios = async function (props = {}) {
  var gett = LOCAL_STORAGE.userToken;
  var locales = "en-IN";

  let congData = JSON.stringify({
    customerNumber: +LOCAL_STORAGE.customerNo,
    userId: LOCAL_STORAGE.userId,
    customer_no: +LOCAL_STORAGE.customerNo,
    user_id: +LOCAL_STORAGE.userId,
    customerNo: +LOCAL_STORAGE.customerNo,
    searchTerm: props.searchTerm,
    ...props.readItems
  });

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    : `${process.env.REACT_APP_BASE_URL}/masters/${props.url}/${props.uniqueId}`;

  if (props.completeURL) {
    try {
      return new Promise((respolve, reject) => {
        axios
          .delete(apiURL, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
            params: {
              customerNumber: LOCAL_STORAGE.customerNo,
              userId: LOCAL_STORAGE.userId,
              customer_no: +LOCAL_STORAGE.customerNo,
              user_id: +LOCAL_STORAGE.userId,
              customerNo: +LOCAL_STORAGE.customerNo,
            },
            data: congData,
          })
          .then((res) => {
            respolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  } else {
    try {
      return new Promise((respolve, reject) => {
        axios
          .delete(apiURL, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
            data: congData,
          })
          .then((res) => {
            if (res.data.status === 200) {
              respolve(res);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            console.log("error while deletion", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
};
export default DeleteAxios;
